import React from "react";
import { getCellColor, sxStyles } from "../sharedStyles";
import { SxProps, Typography } from "@mui/material";
import { IPriceItinerary } from "../interfaces.lowPrice";
import { InfoIcon } from "./InfoIcon";
import { ReturnValue } from "use-count-up";
import {
  formatCurrency,
  formatPriceNoCurrency,
  getStops,
  useConfig,
} from "@thekilroygroup/shared-ui";
import { useTranslations } from "../../../hooks/useTranslations";

interface IProps {
  selectedItineraryId: string | null;
  priceItinerary: IPriceItinerary;
  maxMin: { max: number; min: number };
  locale: string;
  showYouthStudent: boolean;
  animatedPrice: ReturnValue;
}

export const MobileButtonInner = (props: IProps) => {
  const {
    selectedItineraryId,
    priceItinerary,
    maxMin,
    showYouthStudent,
    animatedPrice,
  } = props;

  const { locale } = useConfig();
  const id = showYouthStudent
    ? priceItinerary.studentOrYouthData.id
    : priceItinerary.id;

  const cellColorStyles: SxProps = {
    ...getCellColor(selectedItineraryId === id, priceItinerary.price, maxMin),
  };

  const {
    translations: {
      searchResults: { stops },
    },
  } = useTranslations();

  return (
    <>
      <Typography variant="bodySmall" sx={{ ...cellColorStyles }}>
        {formatCurrency(priceItinerary.currency, locale)}

        {showYouthStudent && (
          <InfoIcon
            priceItinerary={priceItinerary}
            selectedItineraryId={selectedItineraryId}
          />
        )}
      </Typography>
      <Typography
        variant="titleMedium"
        weight="bold"
        sx={{ ...cellColorStyles }}
      >
        {formatPriceNoCurrency(animatedPrice, locale)}
      </Typography>
      <Typography
        variant="titleExtraSmall"
        fontWeight="400"
        sx={{ ...cellColorStyles }}
      >
        {getStops(priceItinerary.returnStops, stops)}
      </Typography>
    </>
  );
};
